import { render } from "./Suggestions.vue?vue&type=template&id=75d267ad&scoped=true"
import script from "./Suggestions.vue?vue&type=script&lang=js"
export * from "./Suggestions.vue?vue&type=script&lang=js"

import "./Suggestions.vue?vue&type=style&index=0&id=75d267ad&scoped=true&lang=css"
import "./Suggestions.vue?vue&type=style&index=1&id=75d267ad&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75d267ad"]])

export default __exports__